import AuthService from './AuthService';
import axios from 'axios';

const userCreationErrorKeys = new Map([
    ["A user with this username already exists. Please use a different username.", "users.creationErrors.usernameExists"],
    ["This email address or phone number is already used by another user.", "users.creationErrors.aliasExists"],
    ["Invalid user details. Please check the username, email address, and phone number.", "users.creationErrors.invalidDetails"],
    ["Too many requests. Please wait a moment before trying again.", "users.creationErrors.rateLimited"],
    ["Could not finish creating the user. Please contact an administrator.", "users.creationErrors.creationIncomplete"],
    ["Network Error", "users.creationErrors.network"],
]);

export const getUserCreationErrorMessage = (error, t) => {
    const key = userCreationErrorKeys.get(error.message);
    const message = key ? t(key, { defaultValue: error.message }) : error.message;
    return t('users.createFailed', { message });
};

class UserService{
    constructor() {
        this.apiBaseUrl=process.env.REACT_APP_CHATBOT_API_URL;
    }

    async getUsers(profile){
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const loginAsUri = loginAs ? `&loginAs=${loginAs}` : '';
        const response = await fetch(`${this.apiBaseUrl}private/users?profile=${profile}${loginAsUri}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log('user service called');
        const data = await response.json();
        return data;
    }

    async getUser(username){
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const loginAsUri = loginAs ? `&loginAs=${loginAs}` : '';
        const response = await fetch(`${this.apiBaseUrl}private/users/${username}?${loginAsUri}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log('user service called');
        const data = await response.json();
        return data;
    }

    async enableUser(userName, enable){
        const token = AuthService.getAccessToken();
        const response = await fetch(`${this.apiBaseUrl}private/users/${userName}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ enable: enable }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);

        }
    }

    async updateUser(user){
        const token = AuthService.getAccessToken();
        console.log(`updating user ${user}`);
        const response = await fetch(`${this.apiBaseUrl}private/users/${user.username}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(user),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response;
    }

    async deleteUser(userName){
        const token = AuthService.getAccessToken();
        const response = await fetch(`${this.apiBaseUrl}private/users/${userName}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        if (!response.ok) {
            const errorDetails = await response.text();
            throw new Error(`HTTP error! Status: ${errorDetails}`);
        }
        return response;
    }

    async addUser(user){
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const loginAsUri = loginAs ? `?loginAs=${loginAs}` : '';
        try {
            return await axios.post(`${this.apiBaseUrl}private/users${loginAsUri}`, user, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
        } catch (error) {
            const detail = error.response?.data?.detail;
            if (typeof detail === 'string' && detail.trim()) {
                error.message = detail;
            }
            throw error;
        }
    }
}
const userService = new UserService();
export default userService;